import React from 'react'
import { defineBlock, useEditor } from '@smartfire/js-block-engine'
import { ReactComponent as Arrow } from './arrow.svg'
import style from './block.module.scss'

function Block({ breadcrumb }) {
    const { isEditing } = useEditor()

    return breadcrumb ? (
        <ol className={style.block}>
            {breadcrumb &&
                breadcrumb.length > 0 &&
                breadcrumb.map((el) => {
                    if (el.url) {
                        return [
                            <li key={el.id}>
                                <a className={style.link} href={isEditing ? false : el.url}>
                                    <span dangerouslySetInnerHTML={{ __html: el.name }} />
                                </a>
                            </li>,
                            <Arrow />,
                        ]
                    } else {
                        return (
                            <li key={el.id}>
                                <span dangerouslySetInnerHTML={{ __html: el.name }} />
                            </li>
                        )
                    }
                })}
        </ol>
    ) : null
}

export default defineBlock({
    Block,
    smartProps: {},
    setup: {
        title: "Fil d'ariane",
    },
})
